/* Imports */
import React from 'react'

/* Functional Component */
function Icons(props) {
  return (
    <img className='w-4 ml-4 md:ml-5' src={props.icon} alt='' />
  )
}

/* Exports */
export default Icons